import React from 'react';
import './PropertyDetail.css';

function PropertyDetail({ icon, label, value }) {
  return (
    <div className="feature-item">
      {icon && <img src={icon} alt={label} className="feature-icon" />}
      <div className="feature-content">
        <div className="feature-label">{label}:</div>
        <div className="feature-value">{value}</div>
      </div>
    </div>
  );
}

export default PropertyDetail;